// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1OcCW","title":"Images45_title__3a90t","images":"Images45_images__uLuHY"};